"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import RequiresAuthentication from "@/components/RequiresAuthentication";
// comment

function Home() {
  const router = useRouter();

  useEffect(() => {
    router.push('/chat-workspace');
  }, [router]);

  return null;
}

export default RequiresAuthentication(Home);